import queryString from "query-string";

import { NLIS_HOLDINGS } from "constants/actionTypes";

import { serializeNlisHolding } from "lib/serializers/nlisHoldings";

import { offlineActionCreator } from "./lib";

interface NlisHoldingsUrlOptions {
  changesSince?: string;
}

const urlCreator = ({ changesSince }: NlisHoldingsUrlOptions = {}) =>
  queryString.stringifyUrl({
    url: "/v2/nlis/holdings/",
    query: {
      changesSince,
    },
  });

export const NlisHoldingsAction = offlineActionCreator(
  NLIS_HOLDINGS,
  serializeNlisHolding,
  urlCreator,
  false,
);
